import React from "react";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import Slide from "../../utils/images/slide-1.jpg";
import styled from "styled-components";
const Layout = styled.div`
  margin-top: 0;
  text-align: center;
  .name {
    font-size: 35px;
    font-family: "Oswald" sans-serif;
    color: white;
  }
`;
function StoryFooter() {
  return (
    <>
      <Layout>
        <div style={styles.bgParallax}>
          <div>
            <HeartStyle>
              <span className="white-line"></span>
              <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
              <HeartFilled
                style={{
                  fontSize: 19,
                  marginLeft: -5,
                  color: "white",
                }}
              />
              <span className="white-line"></span>
            </HeartStyle>
            <p>
              <h3 className="name">Victor & Ufedo</h3>
            </p>
          </div>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  bgParallax: {
    background: `url(${Slide})`,
    height: 500,
    backgroundSize: "cover",
    // backgroundAttachment: "fixed",
    backgroundPosition: "top 50%",
    display: "grid",
    placeItems: "center",
    objectFit: "cover",
  },
};

export default StoryFooter;
